module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 136
// module chunks = 0